import Repository from './Repository';

const resource = '/v1/users/';

export default {
  login(payload) {
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}login`, payload)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  logout() {
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}/logout`, {})
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
};
